  <template>
  <div class="app-container">
    <list ref="list" :can-price="$permission.canPrice()">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="onAddPurchase" icon="el-icon-plus">生成采购订单</el-button>
      </template>
      <template slot="column">
        <!-- <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text">
              编辑
            </el-button>
            <el-button v-if="$permission.canReview() && row.Status == 2" type="text" @click="edit(row)">查看</el-button>
          </template>
        </el-table-column> -->
      </template>
    </list>
    <!-- <edit-dialog ref="editDialog"></edit-dialog> -->
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/production/clothmanagement/newdemand/list";

export default {
  name: "newdemand",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/pr/prGetDoc").default,
      puOrderApi: require("@/api/pu/puOrder").default,
    };
  },
  methods: {
    onAddPurchase(){
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要生成采购订单的数据");
        return;
      }
      this.$confirm("确认生成采购订单所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.OrderProductNo);
        const o = {
          OrderProductNos:ids
        }
        this.puOrderApi.generatePurchase(o).then((res) => {
          if (res.Code === 0) {
            this.$message.success("生成成功");
          }else{
            this.$message.error(res.Msg);
          }
      });
      }).catch(() => { });
    },
    edit({ DocId }) {
      let id = DocId;
      this.api.info(id).then((res) => {
        if (res.Code === 0) {
          this.toURL({
            name: "editoutsourcingpicking",
            params: {
              type: "edit",
              data: res.Data,
            },
          });
        } else {
          this.$message({
            type: "warning",
            message: res.Msg,
          });
        }
      });
    },
    create() {
      this.toURL({
        name: "editoutsourcingpicking",
        params: {
          type: "create",
        },
      });
    },
    toURL(o) {
      this.$router.push(o);
    },
  },
};
</script>
